module.exports = __webpack_public_path__ + "static/media/0026_IMG_LES_MURS_SLOE_W_VSL2100_CHEVRON.766c30a2.png";